<div class="addrecord-container">
  <div class="record-title">
    <h1 l10nTranslate>shared.addRecord</h1>
    <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
  </div>

  <div class="recordtitle-content">
    <div mat-dialog-content>
      <div class="recordsearch-bar">
        <mat-form-field (keydown.enter)="searchRecord()" appearance="outline">
          <input
            matInput
            type="text"
            autocomplete="no-autofill"
            [placeholder]="'shared.searchRecord' | xTranslate"
            [formControl]="searchRecordFC"
          />
          <!-- <i class="fa fa-search recordsearchicon"></i> -->
          <mat-icon matSuffix class="search">search</mat-icon>
        </mat-form-field>
      </div>
      <div class="records">
        <table [formGroup]="recordFormGroup" aria-hidden="true">
          <thead class="export-labels">
            <tr>
              <th scope="col" l10nTranslate>shared.sRecordType</th>
              <th scope="col" l10nTranslate>shared.sRecordID</th>
              <th scope="col" l10nTranslate>shared.recordAddress</th>
            </tr>
          </thead>
          <tbody class="export-input">
            <tr>
              <th scope="col">
                <mat-form-field appearance="outline">
                  <mat-select hideSingleSelectionIndicator="true" [formControl]="recordTypeId" disableOptionCentering>
                    <mat-option *ngFor="let recordType of recordTypeOptions" [value]="recordType.key"
                      >{{ recordType.value | uppercase }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </th>
              <th scope="col">
                <mat-form-field appearance="outline">
                  <input matInput type="number" miqOnlyNumbers autocomplete="no-autofill" [formControl]="recordID" />
                </mat-form-field>
              </th>
              <th scope="col">
                <mat-form-field appearance="outline">
                  <input matInput type="text" autocomplete="no-autofill" [formControl]="recordDesc" />
                </mat-form-field>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="addRecord()" [disabled]="!recordFormGroup.valid" l10nTranslate>
      shared.sAdd
    </button>
  </div>
</div>
